package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class MoneyAmount(
    val currency: String = "USD",
    val value: Double = 0.0
)

@Serializable
data class BillingSummary(
    val currentBalance: MoneyAmount = MoneyAmount(),
    val withdrawnTotal: MoneyAmount = MoneyAmount(),
    val pendingPayouts: MoneyAmount = MoneyAmount()
)

@Serializable
enum class PayoutStatus {
    PENDING,
    PROCESSING,
    PAID,
    REJECTED
}

@Serializable
enum class PayoutMethod {
    ETRANSFER_CANADA,
    WISE
}

@Serializable
data class PayoutRequest(
    val id: Long,
    val createdAt: String,
    val amount: MoneyAmount,
    val status: PayoutStatus,
    val method: PayoutMethod,
    val details: Map<String, String> = emptyMap(),
    val note: String? = null,
    val rejectionReason: String? = null,
    val processedAt: String? = null
)

@Serializable
data class OrganizerRequisites(
    val bankName: String? = null,
    val accountNumber: String? = null,
    val recipientName: String? = null,
    val inn: String? = null,
    val kpp: String? = null,
    val bik: String? = null
)

@Serializable
data class SoldTicketSummary(
    val id: String,
    val eventName: String,
    val buyerName: String,
    val soldAt: String,
    val quantity: Int,
    val grossAmount: MoneyAmount = MoneyAmount(),
    val serviceFee: MoneyAmount = MoneyAmount(),
    val netRevenue: MoneyAmount = MoneyAmount()
)

@Serializable
data class BillingStats(
    val grossSales: MoneyAmount = MoneyAmount(),
    val fees: MoneyAmount = MoneyAmount(),
    val netRevenue: MoneyAmount = MoneyAmount()
)

@Serializable
data class BillingOverview(
    val summary: BillingSummary = BillingSummary(),
    val payoutRequests: List<PayoutRequest> = emptyList(),
    val requisites: OrganizerRequisites? = null,
    val soldTickets: List<SoldTicketSummary> = emptyList(),
    val stats: BillingStats = BillingStats()
)
